import { tryCatchFallback } from "lopermut"
import { createContext, useContext, useEffect, useState } from "react"
import { TimeFrame, TimeFrameEnum, TimeFrameSchema } from "schema"

const STORAGE_KEY = "campaign-timeframe"

const CampaignTimeframeContext = createContext<{
  timeFrame: TimeFrame
  setTimeFrame: (timeFrame: TimeFrame) => void
}>({
  timeFrame: TimeFrameEnum.Last3Months,
  setTimeFrame: () => {},
})

const getInitialTimeFrame = (): TimeFrame => {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (!stored) return TimeFrameEnum.Last3Months

  const parsed = tryCatchFallback(
    () => (stored.startsWith("{") ? JSON.parse(stored) : stored),
    undefined,
  )
  const result = TimeFrameSchema.safeParse(parsed)

  return result.success ? result.data : TimeFrameEnum.Last3Months
}

export const CampaignTimeFrameProvider = ({ children }: React.PropsWithChildren) => {
  const [timeFrame, setTimeFrame] = useState<TimeFrame>(getInitialTimeFrame)

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(timeFrame))
  }, [timeFrame])

  return (
    <CampaignTimeframeContext.Provider value={{ timeFrame, setTimeFrame }}>
      {children}
    </CampaignTimeframeContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useCampaignTimeFrame = () => {
  const context = useContext(CampaignTimeframeContext)
  if (!context)
    throw new Error("useCampaignTimeframe must be used within a CampaignTimeframeProvider")
  return context
}
